/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */

/**
 * unique identifier for each routes
 */
export enum RouteCodes {
  // main routes
  logon = 'LOGON',
  activate = 'ACTIVATE',
  exit = 'EXIT',
  dummy = 'DUMMY',
  settings = 'SETTINGS',
  error = 'ERROR',
  position = 'POSITION',
  reservedArea = 'RESERVED-AREA',
  anonymous = 'ANONYMUS',
  // reserved area children routes
  dashboard = 'DASHBOARD',
  customerData = 'CUSTOMER-DATA',
  // anonymous area
  anonymousSimulation = 'ANONYMUS-SIMULATION',
  onboarding = 'ONBOARDING',
  // position children routes
  welcome = 'WELCOME',
  summary = 'SUMMARY',
  finish = 'FINISH',
  quotation = 'QUOTATION',
  quotationCalculate = 'QUOTATION-CALCULATE',
  obligations = 'OBLIGATIONS',
  resolution = 'RESOLUTION',
  recognition = 'RECOGNITION',
  consents = 'CONSENTS',
  documentsRequest = 'DOCUMENTS-REQUEST',
  adequacy = 'ADEGUACY',
  contractSigning = 'CONTRACT-SIGNING',
  waiting = 'WAITING',
  customerInfo = 'CUSTOMER-INFO',
  financialData = 'FINANCIAL-DATA',
  notes = 'NOTES',
  tfrReleaseQuote = 'TFR-RELEASE-QUOTE',
  ceilingReduction = 'CEILING-REDUCTION',
  atcChoice = 'ATC-CHOICE',
  dataCollection = 'DATA-COLLECTION',
  usesReport = 'USES-REPORT',
  withdraw = 'WITHDRAW'
}
